import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import "braft-editor/dist/index.css";
import configStore from "./stores";
import App from './App';
import './index.less';

const store = configStore();

declare global {
  interface Window {
    globeLanguages: any;
    store: any;
  }
}

window.store = store;

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);